var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { UserImportExposeGroup } from '../interface/user-import-expose-group';
export class ImportValidationResponseDto {
}
__decorate([
    Expose({ groups: [UserImportExposeGroup.MODEL, UserImportExposeGroup.READ] }),
    ApiProperty({ type: () => String, description: 'Import process id. Can be used to download Import Report.' }),
    __metadata("design:type", String)
], ImportValidationResponseDto.prototype, "id", void 0);
//# sourceMappingURL=import-validation-response.dto.js.map